import { Injectable } from '@angular/core';
import { IMenuOption } from 'src/app/domain/interfaces/menu/menu-option';
import { FeatureProduct } from 'src/app/domain/models/funnel/feature-product';
import { BrandService } from '../brand-service/brand.service';
import { IBrandResources } from 'src/app/domain/interfaces/brand/interface-brand-resources';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  constructor(private brandService: BrandService) { }

  getMenu(): Array<IMenuOption> {
    let menuItems: Array<IMenuOption> = [
      {
        Id: 1,
        FeatureProduct: [FeatureProduct.BaseProduct],
        Title: 'Dashboard',
        Path: '/member-portal/dashboard',
        SubOptions: [],
      },
      {
        Id: 2,
        FeatureProduct: [FeatureProduct.BaseProduct],
        Title: 'Financial Tools',
        Path: '/member-portal/financial-tools',
        SubOptions: [
          {
            Id: 1,
            Path: 'financial-tools/financial-manager',
            Title: 'Financial Manager',
            SubOptions: [],
            HideForBrands: ["members.finsightsai.com", "stage.finsightsai.com"],
          },
          {
            Id: 2,
            Path: 'financial-tools/health-score',
            Title: 'Financial Health Score',
            SubOptions: [],
            HideForBrands: ["members.finsightsai.com", "stage.finsightsai.com"]
          },
          {
            Id: 3,
            Path: 'financial-tools/financial-insights',
            Title: 'Finsights',
            SubOptions: [],
            HideForBrands: ["members.finsightsai.com", "stage.finsightsai.com"]
          },
        ],
        HideForBrands: ["members.finsightsai.com", "stage.finsightsai.com"]
      },
      {
        Id: 3,
        FeatureProduct: [FeatureProduct.BaseProduct],
        Title: 'Tutorials',
        Path: '',
        SubOptions: [
          {
            Id: 1,
            Title: 'PFI Tutorial',
            Path: '/member-portal/tutorials/pfm/1',
            SubOptions: [],
            HideForBrands: ["members.finsightsai.com", "stage.finsightsai.com"],
          },
          {
            Id: 2,
            FeatureProduct: [FeatureProduct.FinancialInsights, FeatureProduct.CompleteBundle, FeatureProduct.FreeUpsell],
            Title: 'Finsights',
            Path: '/member-portal/tutorials/financial-insights/1',
            HideIfFeatureProductIsDisabled: true,
            SubOptions: [],
            HideForBrands: [""],
          },
          {
            Id: 3,
            Title: 'Financial Health Score',
            Path: '/member-portal/tutorials/financial-health-score/1',
            SubOptions: [],
            HideForBrands: [
              "members.pfiverify.com", 
              "members.getpfiverify.com",
              "members.financeify.co",
              "members.getfinanceify.com",
              "members.finsightsai.com",
              "members.pfisimplify.com",
              "wwww.verifyfinancialprofile.com",
              "members.verifyfinancialprofile.com",
              "stage.pfiverify.com",
              "stage.financeify.co",
              "stage.financeify.com",
              "stage.finsightsai.com",
              "stage.pfisimplify.com",
              "stage.pfi-verify.com",
              "stage.myfinanceify.com",
            ]
          },
          {
            Id: 3,
            Title: 'Financial Health Score',
            Path: '/member-portal/tutorials/financial-health-score/3',
            SubOptions: [],
            HideForBrands: [
              "localhost:4200",
              "uspfm-web-site-qa.s3-website-us-east-1.amazonaws.com",
              "members.pfiverify.com",
              "members.getpfiverify.com",
              "members.getfinanceify.com",
              "members.financeify.co",
              "members.finsightsai.com",
              "members.pfisimplify.com",
              "stage.pfiverify.com",
              "stage.financeify.co",
              "stage.financeify.com",
              "stage.finsightsai.com",
              "stage.pfisimplify.com",
              "stage.pfi-verify.com",
              "stage.myfinanceify.com",
            ]
          },
          {
            Id: 3,
            Title: 'Financial Health Score',
            Path: '/member-portal/tutorials/financial-health-score/4',
            SubOptions: [],
            HideForBrands: [
              "uspfm-web-site-qa.s3-website-us-east-1.amazonaws.com",
              "localhost:4200",
              "members.pfiverify.com",
              "members.getpfiverify.com",
              "members.financeify.co",
              "members.getfinanceify.com",
              "members.verifyfinancialprofile.com",
              "members.finsightsai.com",
              "members.pfisimplify.com",
              "stage.pfiverify.com",
              "stage.financeify.co",
              "stage.financeify.com",
              "stage.finsightsai.com",
              "stage.pfisimplify.com",
              "stage.pfi-verify.com",
              "stage.myfinanceify.com",
            ]
          },
          {
            Id: 3,
            Title: 'Financial Health Score',
            Path: '/member-portal/tutorials/financial-health-score/5',
            SubOptions: [],
            HideForBrands: [
              "uspfm-web-site-qa.s3-website-us-east-1.amazonaws.com",
              "localhost:4200",
              "members.getpfiverify.com",
              "members.financeify.co",
              "members.getfinanceify.com",
              "members.verifyfinancialprofile.com",
              "members.finsightsai.com",
              "members.pfisimplify.com",
              "stage.financeify.co",
              "stage.financeify.com",
              "stage.finsightsai.com",
              "stage.pfisimplify.com",
              "stage.myfinanceify.com",
            ]
          },
          {
            Id: 3,
            Title: 'Financial Health Score',
            Path: '/member-portal/tutorials/financial-health-score/6',
            SubOptions: [],
            HideForBrands: [
              "localhost:4200",
              "uspfm-web-site-qa.s3-website-us-east-1.amazonaws.com",
              "members.pfiverify.com", 
              "members.getpfiverify.com",
              "members.getfinanceify.com",
              "members.verifyfinancialprofile.com",
              "members.finsightsai.com",
              "members.pfisimplify.com",
              "stage.pfiverify.com",
              "stage.finsightsai.com",
              "stage.pfisimplify.com",
              "stage.pfi-verify.com",
            ]
          },
          {
            Id: 3,
            Title: 'Financial Health Score',
            Path: '/member-portal/tutorials/financial-health-score/7',
            SubOptions: [],
            HideForBrands: [
              "localhost:4200",
              "uspfm-web-site-qa.s3-website-us-east-1.amazonaws.com",
              "members.pfiverify.com", 
              "members.verifyfinancialprofile.com",
              "members.financeify.co",
              "members.getfinanceify.com",
              "members.finsightsai.com",
              "members.pfisimplify.com",
              "stage.pfiverify.com",
              "stage.financeify.co",
              "stage.financeify.com",
              "stage.finsightsai.com",
              "stage.pfisimplify.com",
              "stage.pfi-verify.com",
              "stage.myfinanceify.com",
            ]
          },
          {
            Id: 3,
            Title: 'Financial Health Score',
            Path: '/member-portal/tutorials/financial-health-score/8',
            SubOptions: [],
            HideForBrands: [
              "localhost:4200",
              "uspfm-web-site-qa.s3-website-us-east-1.amazonaws.com",
              "members.pfiverify.com", 
              "members.getpfiverify.com",
              "members.financeify.co",
              "members.getfinanceify.com",
              "members.finsightsai.com",
              "members.verifyfinancialprofile.com",
              "members.pfisimplify.com",
              "stage.pfiverify.com",
              "stage.financeify.co",
              "stage.financeify.com",
              "stage.finsightsai.com",
              "stage.pfisimplify.com",
              "stage.pfi-verify.com",
              "stage.myfinanceify.com",
            ]
          },
          {
            Id: 3,
            Title: 'Financial Health Score',
            Path: '/member-portal/tutorials/financial-health-score/9',
            SubOptions: [],
            HideForBrands: [
              "localhost:4200",
              "uspfm-web-site-qa.s3-website-us-east-1.amazonaws.com",
              "members.pfiverify.com", 
              "members.getpfiverify.com",
              "members.financeify.co",
              "members.verifyfinancialprofile.com",
              "members.finsightsai.com",
              "members.pfisimplify.com",
              "stage.pfiverify.com",
              "stage.financeify.co",
              "stage.financeify.com",
              "stage.finsightsai.com",
              "stage.pfisimplify.com",
              "stage.pfi-verify.com",
              "stage.myfinanceify.com",
            ]
          },
          {
            Id: 3,
            Title: 'Financial Health Score',
            Path: '/member-portal/tutorials/financial-health-score/10',
            SubOptions: [],
            HideForBrands: [
              "localhost:4200",
              "uspfm-web-site-qa.s3-website-us-east-1.amazonaws.com",
              "members.pfiverify.com", 
              "members.getpfiverify.com",
              "members.financeify.co",
              "members.getfinanceify.com",
              "members.verifyfinancialprofile.com",
              "members.finsightsai.com",
              "stage.pfiverify.com",
              "stage.financeify.co",
              "stage.financeify.com",
              "stage.finsightsai.com",
              "stage.pfi-verify.com",
              "stage.myfinanceify.com",
            ]
          },
        ],
      },
      {
        Id: 4,
        FeatureProduct: [FeatureProduct.BaseProduct],
        Title: 'Credit Tool',
        Path: '/member-portal/credit-tool',
        SubOptions: [],
        HideForBrands: ["members.finsightsai.com", "stage.finsightsai.com"]
      },
      {
        Id: 5,
        FeatureProduct: [FeatureProduct.BaseProduct],
        Title: 'Income',
        Path: '/member-portal/payroll',
        SubOptions: [],
        HideForBrands: ["members.finsightsai.com", "stage.finsightsai.com"]
      },
      {
        Id: 6,
        FeatureProduct: [FeatureProduct.BaseProduct],
        Title: 'Rewards',
        Path: '/member-portal/reward',
        SubOptions: [],
        HideForBrands: ["members.finsightsai.com", "stage.finsightsai.com"]
      }
    ];

    this.brandService.getBrandResources().subscribe((brandResourcesResponse: IBrandResources) => {
      menuItems.forEach(menuItem => {
        const pfmTutorialItem = menuItem.SubOptions?.find(subItem => subItem.Title == 'PFI Tutorial');
        if (pfmTutorialItem && brandResourcesResponse?.brandLabel) {
          pfmTutorialItem.Title = brandResourcesResponse?.brandLabel + ' Tutorial';
        }
      });
    });     

    return menuItems;
  }
}
